<template>
  <div class="dilinkTabs header">
    <el-tabs
      class="card"
      type="card"
      v-model="activeName"
      @tab-click="handleClick"
    >
      <el-tab-pane
        class="pane-cont"
        v-for="(item, index) in tabList"
        :name="item.comName"
        :key="index"
        :disabled="isdisabled"
      >
        <span slot="label"><i class="el-icon-date"></i> {{ item.name }}</span>

        <component
          :infoType="infoType"
          :rules="rules"
          :ruleForm="ruleForm"
          :argumentsListData="argumentsListData"
          :certificstuonFileData="certificstuonFileData"
          :argSelectedListData="argSelectedListData"
          :selectFile="selectFile"
          :tenantQualParaDictEntities1="tenantQualParaDictEntities1"
          :tenantQualParaDictEntities2="tenantQualParaDictEntities2"
          :is="componentsName"
          @submitfnchild="submitFn"
          @subAuditfnchild="subAuditFn"
          @changeTab="changeTab"
          @lieinfochild="lieinfoChild"
          @selectFileParent="selectFileParent"
          :auditMessageList="auditMessageList"
        ></component>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import commonTable from "./components/index";
import basicInfo from "./components/basicInfo";
import certificstuonFile from "./components/certificstuonFile";
import argumentsList from "./components/argumentsList";
import checkInfo from "./components/checkInfo";
import {
  tenantdictdetail,
  submit,
  subAudit,
  dictionarylist,
  companyAuthFiles,
  serialNoGen,
} from "./reqApi";

export default {
  name: "fund-add-capital",
  components: {
    commonTable,
    argumentsList,
    certificstuonFile,
    basicInfo,
    checkInfo,
  },
  computed: {},
  data() {
    return {
      auditMessageList: [],
      infoType: 0,
      isonSubmit: true, //是否可以保存
      isdisabled: false, // 标签栏是否禁用
      selectFile: [],
      argumentsListData: [], //评估参数列表字典数据
      certificstuonFileData: [], //企业资质文件字典数据
      argSelectedListData: [], //评估参数列表已选数据
      objInfo: {},
      componentsName: "basicInfo",
      activeName: "basicInfo",
      tabList: [
        {
          name: "基本信息",
          comName: "basicInfo",
        },
        {
          name: "评估参数列表",
          comName: "argumentsList",
        },
        {
          name: "企业资质文件",
          comName: "certificstuonFile",
        },
      ],
      ruleForm: {
        evid: "",
        tenandId: "", //当前资金方id
        tenandNm: "", //企业名称
        version: "",
        createTime: "", //创建时间
        contacter: "", //联系人
        tel: "", //手机
        validDateType: "", //有效期类型  固定年
        rmrk: "", //评估说明
        state: "", //状态
      },
      rules: {
        tenandNm: [
          { required: true, message: "请输入资金方", trigger: "change" },
        ],
        contacter: [
          { required: true, message: "请输入联系人", trigger: "change" },
        ],
        tel: [{ required: true, message: "请输入手机号码", trigger: "blur" }],

        validDateType: [
          { required: true, message: "请选择有效期类型", trigger: "change" },
        ],
        rmrk: [
          { required: true, message: "请输入评估说明", trigger: "change" },
        ],
        state: [
          { required: true, message: "请选择是否启用", trigger: "change" },
        ],
      },
      tenantQualParaDictEntities1: [],
      tenantQualParaDictEntities2: [],
    };
  },
  created() {
    this.getList();
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.roleCode = this.currentUser.comRelats[0].roleCode; //GR001 供应商管理员 GR002 供应商操作员 GR003 供应商复核员
    // this.getcompanyAuthFiles();
  },
  mounted(option) {
    console.log("查看", this.$route.query.opType);
    let infoType = this.$route.query.opType;
    // 0 查看   1   修改    3   新增
    if (this.$route.params.evid) {
      // 查看
      if (infoType == 0) {
        this.tabList = [
          {
            name: "基本信息",
            comName: "basicInfo",
          },
          {
            name: "评估参数列表",
            comName: "argumentsList",
          },
          {
            name: "企业资质文件",
            comName: "certificstuonFile",
          },
          {
            name: "审核意见",
            comName: "checkInfo",
          },
        ];
      }
      this.tenantdictdetailGet();
      this.ruleForm.evid = this.$route.params.evid;
      this.isdisabled = false;
      this.infoType = infoType;
    } else {
      console.log("新增");
      this.isdisabled = true;
      // 新增
      //资金方账号   测试写死  上线需要获取

      // let company = JSON.parse(sessionStorage.getItem("company")) || {};
      let company = this.$store.state.user.currentCompany;
      this.ruleForm.tenandId = company.companyNo; //"406891872195182592"
      // 资金提供方
      this.ruleForm.tenandNm = company.companyName;
    }
  },
  methods: {
    selectFileParent(option) {
      this.selectFile = option.selectFile;
    },
    getcompanyAuthFiles() {
      companyAuthFiles().then((res) => {
        console.log("res", res);
      });
    },
    getList() {
      dictionarylist({}).then((res) => {
        let { data } = res;
        let list = [];
        this.argumentsListData = [];
        this.certificstuonFileData = [];
        data.forEach((item) => {
          if (item.paraType == 0) {
            this.argumentsListData.push(item);
          }
          if (item.paraType == 1) {
            this.certificstuonFileData.push(item);
          }
        });
      });
    },
    fnDetail(evid) {},
    tenantdictdetailGet() {
      tenantdictdetail({
        evid: this.$route.params.evid,
      }).then((res) => {
        if (res.data.tenantQualConfigBaseEntity) {
          let tenantQualConfigBaseEntity = res.data.tenantQualConfigBaseEntity;

          this.ruleForm = Object.assign(
            this.ruleForm,
            tenantQualConfigBaseEntity
          );

          let arr = res.data.tenantQualParaDictEntities || [];
          if (arr.length > 0) {
            arr.map((item) => {
              if (item.paraType == 1) {
                this.tenantQualParaDictEntities2.push(item);
                this.selectFile.push(item);
              } else {
                this.tenantQualParaDictEntities1.push(item);
              }
            });
          }
          this.auditMessageList = res.data.auditMessageList;
          this.argSelectedListData = this.tenantQualParaDictEntities1;
          this.certificstuonFileData = this.tenantQualParaDictEntities2;
        }
      });
    },
    handleClick(tab, event) {
      //   sessionStorage.setItem("productPanName", tab.paneName);
      this.activeName = tab.paneName;
      this.componentsName = tab.paneName;
    },
    //参数修改
    lieinfoChild(option) {
      this[option.type] = option.value;
      console.log(option.value, 999999999);
    },
    changeTab(step) {
      console.log("changeTab", this.tabList[step].comName);
      this.activeName = this.tabList[step].comName;
      this.componentsName = this.tabList[step].comName;
    },
    //提交审核
    subAuditFn(params) {
      // this.handleCheck();
      this.commonFn("audit");
    },
    //保存
    submitFn(params) {
      this.commonFn("save");
    },
    //抽取共同部分
    commonFn(upType) {
      if (!this.tenantQualParaDictEntities1.length) {
        this.$message({
          message: "请选择评估参数列表信息",
          type: "warning",
        });
        return;
      }
      console.log("开始保存");
      if (this.isonSubmit) {
        this.isonSubmit = false;
        this.$nextTick((item) => {
          this.chandlePreserve(upType);
        });
      }
    },
    // 保存
    chandlePreserve(upType) {
      submit({
        tenantQualConfigBaseEntity: this.ruleForm,
        tenantQualParaDictEntities: this.tenantQualParaDictEntities1.concat(
          this.selectFile
        ),
      }).then((res) => {
        if (res.ret == "0") {
          if (upType == "save") {
            this.$message({
              message: "信息保存成功",
              type: "success",
            });
            // this.$router.push("/productManage/productRelease");
          } else {
            console.log("开始创建审核");
            this.handleCheck();
          }

          this.ruleForm.evid = res.data.evid;
        }
        this.$nextTick((item) => {
          this.isonSubmit = true;
        });
      });
    },
    // 提交工作流
    handleCheck() {
      if (this.roleCode == "ZR001") {
        serialNoGen({
          prefix: "WF002-005",
        }).then((serialNoGenRes) => {
          let companyNo = JSON.parse(sessionStorage.getItem("company"))
            .companyNo;
          // let dates = this.$utif.makeTime(new Date().getTime());
          let wfTopic = `资金方名称：${this.ruleForm.tenandNm}，评估代码：${
            this.ruleForm.evid
          }，联系人：${
            this.ruleForm.contacter
          }，创建日期：${this.$utif.makeTime(new Date())}`;

          let businessId = serialNoGenRes.data;
          let xwfs = {
            operatorFlag: "C", //调用工作流的标志："operatorFlag":   C:创建流程 N:提交流程 T:终止流程
            wfDefkey: "WF002-005", //需要走的工作流的流程
            businessId: businessId, //业务编号 WF001-00420220302000074
            wfTopic: wfTopic, //流程内容
            taskCorp: companyNo, //任务方的companyNo
          };
          console.log(xwfs, "weiky");
          window.sessionStorage.setItem("workFlow", JSON.stringify(xwfs));
          subAudit({
            evid: this.ruleForm.evid,
            taskId: businessId,
            // tenantQualParaDictEntities: this.tenantQualParaDictEntities1.concat(info),
          })
            .then((res) => {
              if (res.ret == "0") {
                this.$message({
                  message: "信息提交审核成功",
                  type: "success",
                });
                // console.log(res,"审核")
                //移除工作流
                window.sessionStorage.removeItem("workFlow");
                this.$router.push(
                  "/funding-provider/product/product-management-capital"
                );
              } else {
                // this.$message({
                //   message: res.msg || "msg",
                //   type: "warning",
                // });
              }
            })
            .finally(() => {});
        });
      } else {
        this.$message({
          message: "角色不符，请检查当前用户角色权限",
          type: "warning",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.dilinkTabs {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 90%;
  margin: 10px auto;
  background-color: #fff;
  .card/deep/ .el-tabs__content {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .card {
    flex: 1;
    display: flex;
    flex-direction: column;
    .pane-cont {
      flex: 1;
      display: flex;
      flex-direction: column;
      .component {
        flex: 1;
      }
    }
  }
}
</style>